import {
    IRIS_PROMOTIONALBANNERDATA_GET_ERROR_FSH_FALLBACK,
    IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS,
} from '../actionTypes/PromotionalBannerActionTypes';

function IrisPromotionalBannerReducer(state = [], action) {
    switch (action.type) {
        case IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS:
            return {
                content: action.irisPromotionalBannerData.content,
                isReady: true,
                shippingThresholds: action.irisPromotionalBannerData.shippingThresholds,
            };
        case IRIS_PROMOTIONALBANNERDATA_GET_ERROR_FSH_FALLBACK:
            return {
                shippingThresholds: action.irisPromotionalBannerData.shippingThresholds,
            };
        default:
            return state;
    }
}

IrisPromotionalBannerReducer.reducerName = 'irisPromotionalBannerData';

export default IrisPromotionalBannerReducer;
